import { render, staticRenderFns } from "./followUpDetail.vue?vue&type=template&id=2edee25a&scoped=true"
import script from "./followUpDetail.vue?vue&type=script&lang=js"
export * from "./followUpDetail.vue?vue&type=script&lang=js"
import style0 from "./followUpDetail.vue?vue&type=style&index=0&id=2edee25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edee25a",
  null
  
)

export default component.exports